<template>
  <div class="password">
    <mu-dialog title="修改密码" width="500" :open="open" @close="close">
      <mu-form :model="form" label-position="left" label-width="100">
        <mu-form-item label="原密码">
          <mu-text-field v-model="form.old" type="password"></mu-text-field>
        </mu-form-item>
        <mu-form-item label="新密码">
          <mu-text-field v-model="form.new1" type="password"></mu-text-field>
        </mu-form-item>
        <mu-form-item label="再输入一遍">
          <mu-text-field v-model="form.new2" type="password"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import session from 'utils/session'
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        old: '',
        new1: '',
        new2: ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:open', false)
    },
    submit() {
      if (this.form.new1 !== this.form.new2) {
        this.$alert('两次输入密码不一样')
      } else {
        backend(api.user.updatePassword, this.form).then((res) => {
          if (res.statusCode === 200) {
            this.$toast.success('设置成功,请重新登录')
            session.removeSession('user')
            backend(api.auth.logout).then(() => {
              this.$router.replace('/login')
            })
          } else {
            this.$toast.error(res.msg)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.password {
}
</style>



// WEBPACK FOOTER //
// src/views/admin/password.vue